module.exports = __webpack_public_path__ + "static/img/qnstatus6.5f5f4e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnstatus6.png
// module id = 368
// module chunks = 0